import { Component, OnInit } from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { NotificationService } from '../../../../notification/shared/notification.service'
import { BasketService } from '../../../basket/shared/basket.service'
import { LigneContrat } from '../../../shared/client/contrat/ligne-contrat'

@Component({
  selector: 'app-edit-stock',
  templateUrl: './edit-stock.component.html',
  styleUrls: ['./edit-stock.component.scss']
})
export class EditStockComponent implements OnInit {

  ligne: LigneContrat;

  stockControl: FormControl;
  operation: string = "+";
  qte_stock_prevue: number = 0;
  labelQuantite: string = "Quantité à remettre";

  constructor(
    private route: ActivatedRoute,
    private basketService: BasketService,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.stockControl = new FormControl(undefined, [
      Validators.required
    ]);
    this.route.data.subscribe((data: { ligne: LigneContrat }) => {
      this.ligne = data.ligne;
      this.qte_stock_prevue = this.ligne.qte_stock;
    });

  }

  private success() {
    this.notificationService.notif("La demande de modification de stock a été ajoutée au panier. Elle sera automatiquement supprimée sous 2 jours si elle n'est pas validée.", "notif");
  }

  submitForm() {
    if (this.stockControl.valid && this.ligne != undefined) {
      this.basketService.addBasketLine({
        type: this.operation === "-" ? "DIMINUTION STOCK" : "AUGMENTATION STOCK",
        article: this.ligne.article.code_article,
        newStock: this.qte_stock_prevue
      }).subscribe(res => this.success());
    }
  }

  calculQte() {
    if (this.operation === '+') {
      this.qte_stock_prevue = this.ligne.qte_stock + this.stockControl.value;
      this.labelQuantite = "Quantité à remettre";
    } else {
      this.qte_stock_prevue = this.ligne.qte_stock - this.stockControl.value;
      this.labelQuantite = "Quantité à reprendre";
    }
  }

}
